// @import
import Alpine from "alpinejs";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";

gsap.registerPlugin(SplitText, ScrollTrigger);

Alpine.directive("big-text", (element, {}, { cleanup }) => {
  //
  let splitText = new SplitText(element, {
    tag: "span",
    type: "chars",
  });

  const tween = gsap.to(splitText.chars, {
    color: "var(--color-fg)",
    ease: "power2",
    stagger: 0.7,
    scrollTrigger: {
      trigger: element,
      start: "top 80%",
      end: "bottom 40%",
      scrub: 1,
    },
  });

  cleanup(() => {
    tween.kill();
    splitText.revert();
  });
});
